<div [loading]="loading">
  <ng-container *ngIf="data.customData.notStartedParcelIds.length > 0 && !loading && data?.list?.list">
    <span>Parcely k řešení</span>
    <ul>
      <ng-container *ngFor="let parcelData of getNotStartedParcels()">
        <li>
          <a uiSref="symap.project.parcels.detail" [uiParams]="{id: parcelData.parcel.id}">{{parcelData.parcel|parcelnumber}}</a>
        </li>
      </ng-container>
    </ul>
  </ng-container>

  <ng-container *ngIf="data.customData.inProgressParcelIds.length > 0 && !loading && data?.list?.list">
    <span>Řešené parcely</span>
    <ul>
      <ng-container *ngFor="let parcelData of getInProgressParcels()">
        <li>
          <a uiSref="symap.project.parcels.detail" [uiParams]="{id: parcelData.parcel.id}">{{parcelData.parcel|parcelnumber}}</a>
          <span *ngIf="parcelData.titleId && data.customData.titleId && data.customData.titleId != parcelData.titleId" title="Řešeno na bývalém LV" class="tag tag--danger tag--small is-uppercase ml-5">LV</span>
        </li>
      </ng-container>
    </ul>
  </ng-container>

  <ng-container *ngIf="data.customData.doneParcelIds.length > 0 && !loading && data?.list?.list">
    <span>Vyřešené parcely</span>
    <ul>
      <ng-container *ngFor="let parcelData of getDoneParcels()">
        <li>
          <a uiSref="symap.project.parcels.detail" [uiParams]="{id: parcelData.parcel.id}">{{parcelData.parcel|parcelnumber}}</a>
          <span *ngIf="parcelData.titleId && data.customData.titleId && data.customData.titleId != parcelData.titleId" title="Řešeno na bývalém LV" class="tag tag--danger tag--small is-uppercase ml-5">LV</span>
        </li>
      </ng-container>
    </ul>
  </ng-container>
</div>

